import { all, fork, takeLatest } from "redux-saga/effects";

import actions from "@state/actions";
import clearPendingScans from "./clearPendingScans";
import fetchEvent from "./fetchEvent";
import fetchSearchTicketsByEventApp from "./fetchSearchTicketsByEventApp";
import getEvents from "./getEvents";
import login from "./login";
import logout from "./logout";
import scanTicket from "./scanTicket";
import scanSounds from "./scanSounds";
import searchDeviceTicket from "./searchDeviceTickets";
import setMode from "./setMode";
import syncPendingScans from "./syncPendingScans";
import updatePendingScanCount from "./updatePendingScanCount";
import updateLocalTicket from "./updateLocalTicket";

export default function* sagaWatcher() {
  yield all([
    fork(scanSounds),
    takeLatest(actions.login.type, login),
    // REMOVED: takeLatest(actions.login.success.type, getEvents),
    // getEvents is now called directly from login saga to prevent race condition
    // where orgId may not be set in state before getEvents tries to read it
    takeLatest(actions.logout.type, logout),
    takeLatest(actions.getEvents.type, getEvents),
    takeLatest(actions.fetchEvent.type, fetchEvent),
    takeLatest(
      actions.fetchSearchTicketsByEventApp.type,
      fetchSearchTicketsByEventApp
    ),
    takeLatest(actions.scanTicket.type, scanTicket),
    takeLatest(actions.setMode.type, setMode),
    takeLatest(actions.searchDeviceTickets.type, searchDeviceTicket),
    takeLatest(actions.syncPendingScans.type, syncPendingScans),
    takeLatest(actions.clearPendingScans.type, clearPendingScans),
    takeLatest(actions.updateLocalTicket.type, updateLocalTicket),
    takeLatest(actions.updatePendingScanCount.type, updatePendingScanCount),


  ]);
}
